'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var InputTextarea = function (props) {
    var id = props.id, label = props.label, _a = props.initialValue, initialValue = _a === void 0 ? '' : _a, onChange = props.onChange, _b = props.rowHeight, rowHeight = _b === void 0 ? 1 : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? true : _c, _d = props.resize, resize = _d === void 0 ? 'none' : _d, _e = props.placeholder, placeholder = _e === void 0 ? '' : _e, _f = props.error, error = _f === void 0 ? false : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.readOnly, readOnly = _h === void 0 ? false : _h, onBlur = props.onBlur;
    var _j = React.useState(initialValue), value = _j[0], setValue = _j[1];
    React.useEffect(function () {
        setValue(initialValue);
    }, [initialValue]);
    var handleChange = function (event) {
        setValue(event.target.value);
        if (onChange)
            onChange(event.target.value);
    };
    return (React__default.createElement(styledComponents.Main, null,
        label && typeof label === 'string' && (React__default.createElement(styledComponents.Label, { htmlFor: id, "data-testid": 'label' },
            React__default.createElement(core.Typography, { variant: 'body2' }, label))),
        label && typeof label !== 'string' && (React__default.createElement(styledComponents.Label, { htmlFor: id, "data-testid": 'label' }, label)),
        React__default.createElement(styledComponents.Textarea, { id: id, value: value, onChange: handleChange, rowsMax: rowHeight, rows: rowHeight, fullWidth: fullWidth, multiline: true, resize: resize, placeholder: placeholder, error: error, disabled: disabled, readOnly: readOnly, onBlur: onBlur, inputProps: { 'data-testid': 'input-textarea' } })));
};

module.exports = InputTextarea;
